

















import Vue from 'vue'
import iconExpandRow from '@/assets/svg/rounded/expand-row.svg?inline'
import iconCropRow from '@/assets/svg/rounded/cropped-row.svg?inline'
import { ERowView } from '@/constants/dataTable'
import { localStorageSet } from '@/helpers/localStorage'
import { LocalStorageMutationTypes } from '@/store/modules/local-storage/mutations'

interface Methods {
  changeRowView: (isExpand: boolean) => void
}

interface Data {
  rowView: string
}

export default Vue.extend<Data, Methods, {}, {}>({
  components: {
    iconExpandRow,
    iconCropRow,
  },
  data() {
    return {
      rowView: 'crop',
    }
  },
  methods: {
    changeRowView(isExpand) {
      this.rowView = isExpand ? ERowView.expand : ERowView.crop
      localStorageSet('row_view', this.rowView)
      this.$store.commit(LocalStorageMutationTypes.GetAllSuccess, {
        ['foxgid_row_view']: this.rowView,
      })
    },
  },
  mounted() {
    if (this.$store.getters.getLocalStorage.foxgid_row_view) {
      this.rowView = this.$store.getters.getLocalStorage.foxgid_row_view
    }
  },
})
